import { Card, styled } from "@mui/material";
import { Handle } from "@xyflow/react";

import { DIAGRAM_COLOR } from "../../OrgChart.constants";

export const StyledCard = styled(Card)(() => ({
  border: `2px solid ${DIAGRAM_COLOR}`,
  borderRadius: 8,
  padding: 1,
  alignItems: "center",
}));

export const StyledHandle = styled(Handle)`
  opacity: 0;
  width: 1px;
  height: 1px;
  border: 0;
`;
